import { useEffect, useState } from 'react';

/**
 * Wo die Transportleiste steht (7.62).
 *
 * Sascha, 8. September: die Leiste soll sich verschieben lassen. Wo sie
 * steht, ist eine Entscheidung der Software; wer anders arbeitet, will sie
 * woanders. Zwei Plätze auf der Bühne: unten (wie bisher) und oben. Gezogen
 * wird am Griff, losgelassen rastet sie am näheren Rand ein. Die Wahl gehört
 * dem Gerät wie das Thema, deshalb im Browser gespeichert -- und der Weg
 * zurück steht unter *Mein Konto*.
 */
export type TransportLage = 'unten' | 'oben';

export const TRANSPORT_LAGEN: { id: TransportLage; label: string }[] = [
  { id: 'unten', label: 'Unten' },
  { id: 'oben', label: 'Oben' },
];

const SCHLUESSEL = 'schnitt.transport';

export function geleseneTransportLage(): TransportLage {
  try {
    if (localStorage.getItem(SCHLUESSEL) === 'oben') return 'oben';
  } catch {
    /* Ein Browser ohne Speicher ist kein Grund, nicht zu arbeiten. */
  }
  return 'unten';
}

const horcher = new Set<(lage: TransportLage) => void>();

export function setTransportLage(lage: TransportLage): void {
  try {
    localStorage.setItem(SCHLUESSEL, lage);
  } catch {
    /* siehe oben */
  }
  for (const h of horcher) h(lage);
}

export function useTransportLage(): TransportLage {
  const [lage, setzen] = useState<TransportLage>(geleseneTransportLage);
  useEffect(() => {
    horcher.add(setzen);
    return () => {
      horcher.delete(setzen);
    };
  }, []);
  return lage;
}

/** Wohin die Leiste nach dem Loslassen gehört: an den näheren Rand der Bühne. */
export function lageNachZug(leisteMitteY: number, buehneOben: number, buehneUnten: number): TransportLage {
  return leisteMitteY < (buehneOben + buehneUnten) / 2 ? 'oben' : 'unten';
}
